export const fallBackUserDetails = {
    userName: '',
    email: '',
    isWixUser: false,
    photo: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iYSIgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiByeD0iMTgiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDx1c2UgZmlsbD0iI0RBRUZGRSIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNCMUQ5RjciIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTMwIDM1YzAtNS4xMy0zLjIxOC05LjUwNy03Ljc0NS0xMS4yMjRhOCA4IDAgMSAwLTguNTEgMEM5LjIxOCAyNS40OTMgNiAyOS44NzEgNiAzNXYxaDI0di0xeiIgbWFzaz0idXJsKCNiKSIvPgogICAgPC9nPgo8L3N2Zz4K',
    first: 'Unavailable',
    last: '',
};
export const defaultMainHeaderTexts = {
    signInButton: 'Sign in',
    logoutButton: 'Logout',
    mainLinks: {
        myApps: 'My Apps',
        apiReference: 'API Reference',
        support: 'Support',
        appMarket: 'App Market',
        permissionCatalog: 'Permission Catalog',
        discord: 'Discord',
        resources: 'Resources',
        buildAppDoc: 'Build Apps Documentation',
        apiAndSdk: 'API References',
        appTemplates: 'App Templates',
    },
};
export var MainLinkId;
(function (MainLinkId) {
    MainLinkId["MyApps"] = "my-apps";
    MainLinkId["ApiReference"] = "api-reference";
    MainLinkId["Support"] = "support";
    MainLinkId["AppMarket"] = "app-market";
    MainLinkId["PermissionCatalog"] = "permission-catalog";
    MainLinkId["Discord"] = "discord";
    MainLinkId["Resources"] = "resources";
    MainLinkId["buildAppDoc"] = "build-app-doc";
    MainLinkId["apiAndSdk"] = "api-and-sdk";
    MainLinkId["appTemplates"] = "appTemplates";
})(MainLinkId || (MainLinkId = {}));
export const links = {
    logo: 'https://dev.wix.com',
    signInButton: 'https://users.wix.com/signin?loginDialogContext=login&referralInfo=HEADER',
    logoutButton: 'https://www.wix.com/signout',
    mainLinks: {
        myApps: 'https://dev.wix.com/apps/my-apps',
        apiReference: 'https://dev.wix.com/api/rest/getting-started',
        support: 'https://devforum.wix.com',
        appMarket: 'https://www.wix.com/app-market',
        permissionCatalog: 'https://bo.wix.com/wow/permissions/permission-catalog',
        discord: 'https://discord.gg/devs-on-wix',
        buildAppDoc: 'https://dev.wix.com/docs/build-apps',
        apiAndSdk: 'https://dev.wix.com/docs/rest/articles/getting-started/overview',
        appTemplates: 'https://dev.wix.com/apps-templates',
    },
};
export const USER_DETAILS_ENDPOINT = 'https://dev.wix.com/dc3/api/user-details';
//# sourceMappingURL=constants.js.map